import { Box, IconButton, InputAdornment } from "@material-ui/core"
import { VisibilityOffOutlined, VisibilityOutlined } from "@material-ui/icons"
import { updateForgotPassword } from "actions/Clerk/users"
import App from "contexts/App"
import { Field, Form, Formik, useFormikContext } from "formik"
import { TextField } from "formik-material-ui"
import PropTypes from "prop-types"
import { useContext } from "react"
import { useState } from "react"
import { useMutation } from "react-query"
import { useHistory } from "react-router-dom"
import * as Yup from "yup"

import LoaderButton from "../../LocalLoadingButton"
import useStyles from "./styles"

const schema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[\d])(?=.*[!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/])(?=.*[A-Z])[A-Za-z\d!@#$%^&*()_\-+={[}\]|\\:;"'<,>.?/]{8,}$/,
      "Requirements: 8 characters, 1 Upper Case & 1 special character"
    ),
  updatePassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required(`Required`),
  pin: Yup.string(),
})

export const Fields = () => {
  const [visibility, setVisibility] = useState(true)
  const classes = useStyles()

  return (
    <>
      <Field
        style={{ marginBottom: "30px" }}
        component={TextField}
        type={visibility ? "password" : "text"}
        name="password"
        fullWidth
        label="New Password"
        variant="outlined"
        FormHelperTextProps={{
          className: classes.formHelperText,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                size="small"
                onClick={() => setVisibility(!visibility)}
              >
                {visibility ? (
                  <VisibilityOutlined color="primary" fontSize="small" />
                ) : (
                  <VisibilityOffOutlined color="primary" fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Field
        component={TextField}
        type={visibility ? "password" : "text"}
        name="updatePassword"
        fullWidth
        label="Confirm New Password"
        variant="outlined"
        FormHelperTextProps={{
          className: classes.formHelperText,
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                size="small"
                onClick={() => setVisibility(!visibility)}
              >
                {visibility ? (
                  <VisibilityOutlined color="primary" fontSize="small" />
                ) : (
                  <VisibilityOffOutlined color="primary" fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </>
  )
}

export const Buttons = () => {
  // LoaderButton grabs formik context and spins automatically
  /* If `submitForm` from `formikContext` returns a Promise, you can pass it
          to `onClick` to automatically show success or error animation */

  const { submitForm } = useFormikContext()
  const classes = useStyles()

  return (
    <Box className={classes.loaderButtonwrapper} marginTop="30px">
      <LoaderButton
        type="button"
        variant="contained"
        color="primary"
        fullWidth
        onClick={submitForm}
      >
        Submit
      </LoaderButton>
    </Box>
  )
}

const ClerkUpdatePasswordForm = ({
  pin,
  FieldsComponent,
  ButtonsComponent,
  handleClose,
  email,
}) => {
  const { openSnackBar } = useContext(App)

  const history = useHistory()
  const resetPassMutation = useMutation(updateForgotPassword)

  const handleSubmit = (values) => {
    if (values.password === values.updatePassword) {
      resetPassMutation
        .mutateAsync({
          password: values.password,
          pin: pin,
          email: email,
        })
        .then(() => [
          openSnackBar({
            message: "Password updated!",
          }),
          setTimeout(() => {
            history.push("/")
            handleClose()
          }, 300),
        ])
        .catch((err) => {
          openSnackBar({
            message: "Error updating password!",
          })
          handleClose()
        })
    }
  }

  return (
    <Formik
      initialValues={{ password: "", updatePassword: "", pin: pin }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      <>
        {FieldsComponent && (
          <FieldsComponent>
            <Form>
              <Fields />
              <button
                type="submit"
                style={{ opacity: "0", visibility: "hidden" }}
              />
            </Form>
          </FieldsComponent>
        )}
        {!FieldsComponent && (
          <Form>
            <Fields />
          </Form>
        )}
        {ButtonsComponent && (
          <ButtonsComponent>
            <Buttons />
          </ButtonsComponent>
        )}
        {!ButtonsComponent && <Buttons />}
      </>
    </Formik>
  )
}

ClerkUpdatePasswordForm.propTypes = {
  pin: PropTypes.object,
  email: PropTypes.object,
  FieldsComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  ButtonsComponent: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  handleClose: PropTypes.func,
}

export default ClerkUpdatePasswordForm
